import React from 'react'

import useTutorialSettings from '../../TutorialSettingsProvider/useTutorialSettings'

import { PrimaryButtonLabels } from './types'

import styles from './PrimaryButtonLabel.module.scss'

type PrimaryButtonLabelProps = {
  label: PrimaryButtonLabels
}

const buttonLabel = {
  [PrimaryButtonLabels.Next]: 'Next',
  [PrimaryButtonLabels.Last]: 'Done',
}

const PrimaryButtonLabel = ({ label }: PrimaryButtonLabelProps) => {
  const { tutorialSettings } = useTutorialSettings()

  const getTextSize = () => {
    if (tutorialSettings.stepIndex === 0) {
      return '20px'
    }
    return '15px'
  }

  return (
    <p
      className={styles.primaryButtonLabel}
      style={{ fontSize: getTextSize() }}
    >
      {buttonLabel[label]}
    </p>
  )
}

export default PrimaryButtonLabel
